import { render, staticRenderFns } from "./OrgSwitcher.vue?vue&type=template&id=777b6c7a&scoped=true&"
import script from "./OrgSwitcher.vue?vue&type=script&lang=js&"
export * from "./OrgSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./OrgSwitcher.vue?vue&type=style&index=0&id=777b6c7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b6c7a",
  null
  
)

export default component.exports